/* Lot « annonces » (AUDIT Tours 564 à 576 ; textes de COMMERCIAL, Tours 70 et 71). Chargé par cfg-coeur sur tous les
   configurateurs, après les autres modules.
   - A-304 : le prix annoncé (menu d'un coin, fenêtre, bulle) est l'écart que le choix produit sur le total, calculé par le
     moteur lui-même : l'état est copié, le choix posé, tout le rendu refait (chaque module y ajoute ses lignes), le total lu,
     puis l'état remis. La bulle nomme les lignes du récapitulatif que le choix ajoute d'office.
   - A-305 : la fenêtre dit ce que le choix remplace, avec l'écart réel, avant APPLIQUER.
   - A-306 : un choix fait dans le menu d'un coin n'est gardé qu'avec APPLIQUER (ou Supprimer) ; ✕, Échap ou un clic ailleurs
     rendent l'état d'avant le choix.
   - A-314 : la bulle d'un choix précédent ne reste pas sur la fenêtre suivante.
   - A-344 : toutes les fenêtres du configurateur, au-dessus du bandeau de consentement ou devant lui (en fin de fichier). */
(function () {
  'use strict';
  function getApp() { try { if (typeof App !== 'undefined' && App && App.S) return App; } catch (e) {} return window.App && window.App.S ? window.App : null; }
  var NB = ' ', SIM = false;
  window.CP_enSimulation = function () { return SIM; };

  /* ── montants et lignes du récapitulatif ── */
  function fmt(c) { return (Math.abs(c) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/[ \s]/g, NB); }
  function signe(c) { return (c < 0 ? '−' : '+') + fmt(c) + NB + '€'; }
  /* dernier montant en € d'un texte (« … x1 = +99,00 € », « … : +120 €/ml × 2,40 ml = +288,00 € »), en centimes */
  function montant(t) {
    var m = String(t).match(/[+−-]?\s*\d[\d\s  .]*(?:,\d{1,2})?\s*€(?!.*€)/); if (!m) return null;
    var v = Number(m[0].replace(/[\s  .€]/g, '').replace('−', '-').replace(',', '.'));
    return isFinite(v) ? Math.round(v * 100) : null;
  }
  /* nom d'une ligne, sans ses montants : « Coins arrondis : 2 × 99,00 € = +198,00 € », « Profondeur du retour 650 mm :
     1,20 ml × 99 €/ml = +118,80 € » (lot « messages 2 ») et les formes d'avant, ci-dessous */
  function libelle(t) {
    return libelleAvant(String(t).replace(/\s*:\s*\d+\s*×\s*[\d\s.,]+€\s*=\s*[+−-]?[\d\s.,]+€\s*$/, '')
      .replace(/\s*:\s*[\d\s.,]+(?:ml|m²)\s*×\s*[\d\s.,]+€\s*\/\s*(?:ml|m²)\s*=\s*[+−-]?[\d\s.,]+€\s*$/, ''));
  }
  /* nom d'une ligne, sans ses montants (« Coins arrondis (+99,00 €) : x1 = +99,00 € » → « Coins arrondis ») */
  function libelleAvant(t) {
    return String(t).replace(/\s*:\s*x\d+\s*=\s*[+−-]?[\d\s  .,]+€\s*$/, '')
      .replace(/\s*:\s*[+−-]?[\d\s  .,]+€\s*\/\s*m[^:]*$/, '')
      .replace(/\s*:\s*[+−-]?[\d\s  .,]+€\s*$/, '')
      .replace(/\s*\([+−-]?[\d\s  .,]+€[^)]*\)/g, '').trim();
  }
  function lire(A) { if (typeof window.CP_chantsParLigne === 'function') { try { window.CP_chantsParLigne(A || getApp()); } catch (e) {} } return lire0(A); }   /* R148-b2 : une ligne par chant avant la lecture */
  function lire0(A) {
    var L = {};
    Array.prototype.forEach.call(document.querySelectorAll('.td-options-list li:not([data-cp-info])'), function (li) {   /* ligne d'information (pièce finie sur 4 côtés : prix dans le prix de base) : pas une option */
      var t = (li.textContent || '').replace(/\s+/g, ' ').trim(), c = montant(t); if (c == null) return;
      var n = libelle(t); L[n] = (L[n] || 0) + c;
    });
    var b = document.getElementById('td-prix-base'), bt = b ? (b.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return { total: Number(A.getCalculatedUnitTotalCents()) || 0, lignes: L, base: { texte: bt, c: montant(bt) } };
  }
  /* écart entre deux lectures : lignes ajoutées et retirées (une ligne déplacée au même montant, « Profondeur 650 mm »
     devenue « Chant arrière du montant gauche… » en stratifié, n'est ni l'une ni l'autre), prix de base */
  function ecart(e0, e1) {
    var plus = [], moins = [];
    Object.keys(e0.lignes).concat(Object.keys(e1.lignes)).forEach(function (n, i, all) {
      if (all.indexOf(n) !== i) return;
      var d = (e1.lignes[n] || 0) - (e0.lignes[n] || 0);
      if (d > 0) plus.push({ nom: n, c: d }); else if (d < 0) moins.push({ nom: n, c: -d });
    });
    /* reclassement au même montant, seulement entre lignes qui ne sont pas des usinages (un bout en biais remplacé par un hors
       équerre au même prix reste un remplacement, dit au client) */
    var usinage = function (n) { return /arrondi|demi-rond|encoche|chanfrein|équerre|biais/i.test(n); };
    plus = plus.filter(function (p) {
      if (usinage(p.nom)) return true;
      var i = -1; moins.some(function (m, j) { if (m.c === p.c && !usinage(m.nom)) { i = j; return true; } return false; });
      if (i < 0) return true; moins.splice(i, 1); return false;
    });
    return { total: e1.total - e0.total, plus: plus, moins: moins, base: (e1.base.c || 0) - (e0.base.c || 0), baseTexte: e1.base.texte, baseAvant: e0.base.texte };
  }

  /* ── simulation : le moteur calcule, l'état revient tel quel ──
     Les rendus de simulation ne programment rien (bulles, placements, cadrage) : setTimeout et requestAnimationFrame y sont
     neutralisés ; un dernier rendu, en simulation lui aussi, remet l'état et la mémoire des modules (types déjà vus de
     cp-modele…), puis un vrai rendu programme les suites habituelles. */
  function copie(o) { return JSON.parse(JSON.stringify(o)); }
  function remet(A, p) { var S = A.S, c = copie(p); Object.keys(S).forEach(function (k) { if (!(k in c)) delete S[k]; }); Object.keys(c).forEach(function (k) { S[k] = c[k]; }); }
  function sansMinuteurs(f) {
    var st = window.setTimeout, raf = window.requestAnimationFrame;
    window.setTimeout = function () { return 0; }; window.requestAnimationFrame = function () { return 0; };
    try { return f(); } finally { window.setTimeout = st; window.requestAnimationFrame = raf; }
  }
  /* fs : fonctions (A) qui posent chacune un choix (false : choix refusé) ; → { avant, apres : [lecture ou null] } */
  function simule(A, fs) {
    var p = copie(A.S), bulle = A.__cpBulle, r = { avant: null, apres: [] };
    SIM = true;
    try {
      sansMinuteurs(function () {
        A.render(); r.avant = lire(A);
        fs.forEach(function (f) {
          remet(A, p); var l = null;
          try { if (f(A) !== false) { A.render(); l = lire(A); } } catch (e) { console.warn('[cp-annonces]', e); }
          r.apres.push(l);
        });
        remet(A, p); A.render();
      });
    } catch (e) { console.warn('[cp-annonces]', e); remet(A, p); }
    finally { SIM = false; A.__cpBulle = bulle; }
    A.render();
    return r;
  }
  window.CP_simule = simule;
  window.CP_ecart = ecart;

  /* ── un choix du menu d'un coin, tel que le clic le pose : refus et ménage de cp-pierre-angle, puis le moteur
     (configurator-main, gestionnaire de .em-opt : valeurs par défaut, type) ── */
  function choix(A, k, t, mode) {
    var S = A.S;
    if (!k || !t) return false;
    if (t !== 'straight' && A._eff && A._eff.edgeTypes && A._eff.edgeTypes[t] !== true) return false;
    if (window.CP_coinRefus && window.CP_coinRefus(A, k, t)) return false;
    if (window.CP_coinAvant) window.CP_coinAvant(A, k, t, mode);
    if (t === 'straight') { if (A.clearEdgeType) A.clearEdgeType(k); else S.edges[k] = 'straight'; return true; }
    if (t === 'bevel') { S.bevel = S.bevel || {}; if (!S.bevel[k]) S.bevel[k] = { dx: 50, dy: 50 }; }
    if (t === 'notch') { S.notch = S.notch || {}; if (!S.notch[k]) S.notch[k] = { dx: 100, dy: 100, offset: 0 }; }
    if (t === 'round1' && !S.roundRadius) S.roundRadius = 30;
    S.edges[k] = t;
    return true;
  }
  function visible(el) { return !!el && el.getClientRects().length > 0 && getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden'; }

  /* ── A-304 : prix du menu d'un coin = écart du total que chaque option produirait, choisie maintenant ── */
  var menuVu = null, calcul = false;
  function prixMenu(A) {
    if (calcul) return;                                                /* un rendu qui rappellerait la mise à jour du menu */
    calcul = true;
    try { prixMenu0(A); } finally { calcul = false; }
  }
  function prixMenu0(A) {
    var menu = document.getElementById('edge-menu'), k = A && A.menuTarget;
    if (!menu || menu.classList.contains('hidden') || !k) return;
    var os = Array.prototype.filter.call(menu.querySelectorAll('.em-opt'), visible);
    var fs = os.map(function (o) {                                     /* option en place comprise : la choisir à nouveau a parfois un effet (« Droit » remet tout le bout droit) */
      var t = o.getAttribute('data-type'), mode = o.getAttribute('data-cp-mode');
      return function (B) { return choix(B, k, t, mode); };
    });
    var r = simule(A, fs);
    os.forEach(function (o, i) {
      var p = o.querySelector('.em-price');
      if (!p) { p = document.createElement('small'); p.className = 'em-price'; o.appendChild(p); }
      var l = r.apres[i];
      p.textContent = l ? (l.total === r.avant.total ? 'même prix' : signe(l.total - r.avant.total)) : '';   /* lot « messages 2 », N44 : jamais « +0,00 € » */
      /* R148-b2 (COMMERCIAL Tour 213, A-294) : coin arrondi (ou demi-rond) impossible ici : dit dans le menu, grisé, sans prix ; le
         toucher ouvre la bulle (cp-pierre-angle) */
      var t = o.getAttribute('data-type'), sp = o.querySelector('span'), rf = (t === 'round1' || t === 'semi') && typeof window.CP_coinRefusMenu === 'function' ? window.CP_coinRefusMenu(A, k, t) : null;
      if (sp && !sp.hasAttribute('data-cp-nom')) sp.setAttribute('data-cp-nom', sp.textContent);
      if (rf && sp) { sp.textContent = (t === 'semi' ? 'Demi-rond' : 'Coin arrondi') + ' : ' + rf; p.textContent = ''; o.style.opacity = '.55'; o.setAttribute('aria-disabled', 'true'); }
      else if (sp && sp.getAttribute('data-cp-nom') !== sp.textContent) { sp.textContent = sp.getAttribute('data-cp-nom'); o.style.opacity = ''; o.removeAttribute('aria-disabled'); }
    });
    menuVu = { k: k, t: Date.now() };
  }
  function enveloppeMenu(A) {
    var o = A.updateMenuSelection; if (typeof o !== 'function' || o.__cpAnn) return;
    A.updateMenuSelection = function () { var r = o.apply(this, arguments); if (!SIM) try { prixMenu(this); } catch (e) { console.warn('[cp-annonces]', e); } return r; };
    A.updateMenuSelection.__cpAnn = true;
    if (o.__cpU) A.updateMenuSelection.__cpU = true;                    /* cp-pierre-angle (menuCoin) est dedans : il ne se remet pas par-dessus */
  }

  /* ── un choix en cours (menu d'un coin) : l'état d'avant, pour l'écart, la bulle et l'annulation (A-306) ── */
  var enCours = null;
  window.addEventListener('click', function (e) {
    var o = e.target && e.target.closest && e.target.closest('#edge-menu .em-opt'); if (!o) return;
    var A = getApp(); if (!A || !A.menuTarget) return;
    if (window.CFG_UI && window.CFG_UI.efface) window.CFG_UI.efface();   /* A-314 : bulles des choix précédents */
    enCours = { k: A.menuTarget, t: o.getAttribute('data-type'), mode: o.getAttribute('data-cp-mode'), photo: copie(A.S), avant: lire(A), garde: false, fenetre: false };
    var c = enCours;
    setTimeout(function () {                                           /* sans fenêtre (demi-rond, refus) : le choix est fait, rien à annuler */
      var p = document.getElementById('edge-dims-popup');
      if (enCours === c && (!p || p.classList.contains('hidden'))) c.garde = true;
    }, 0);
  }, true);
  /* APPLIQUER, Entrée dans un champ de la fenêtre, Supprimer : le choix est gardé si la fenêtre se ferme. A-330 (AUDIT Tour
     619) : refusé (valeur hors bornes, la fenêtre reste ouverte avec ses bornes), il ne garde rien ; ✕ rend alors l'état
     d'avant le choix, sans la coupe que le menu avait posée */
  function valide(c) {
    c.valide = true;
    setTimeout(function () { var p = document.getElementById('edge-dims-popup'); if (enCours === c && p && !p.classList.contains('hidden')) c.valide = false; }, 0);
  }
  window.addEventListener('click', function (e) {
    if (enCours && e.target && e.target.closest && e.target.closest('#edge-dims-popup #edge-apply, #edge-dims-popup #edge-delete')) valide(enCours);
  }, true);
  window.addEventListener('keydown', function (e) {
    if (enCours && e.key === 'Enter' && e.target && e.target.closest && e.target.closest('#edge-dims-popup input')) valide(enCours);
  }, true);

  /* ── A-304, A-305 : la fenêtre ── */
  function nomType(t, mode) {
    return t === 'round1' ? 'coin arrondi' : t === 'semi' ? 'demi-rond' : t === 'notch' ? 'encoche' : t === 'bevel' ? 'chanfrein' :
      t === 'biais' ? (mode === 'hors' ? 'hors équerre' : 'bord en biais') : '';
  }
  /* nom court d'une ligne retirée : son usinage (« Bout gauche, coin avant : bout en biais, retrait 100 mm » → « bout en biais ») */
  function nomCourt(n) {
    var s = n.indexOf(' : ') >= 0 ? n.slice(n.lastIndexOf(' : ') + 3) : n;
    s = s.split(',')[0].replace(/\s*\d+([,.]\d+)?\s*°.*$/, '').trim();
    var R = [[/arrondi/i, 'coin arrondi'], [/demi-rond/i, 'demi-rond'], [/encoche/i, 'encoche'], [/chanfrein/i, 'chanfrein'], [/hors\s+d?'?\s*équerre/i, 'hors équerre'], [/biais/i, 'bord en biais']];
    for (var i = 0; i < R.length; i++) if (R[i][0].test(s)) return R[i][1];
    return s.charAt(0).toLowerCase() + s.slice(1);
  }
  /* nom d'une ligne ajoutée d'office, tel que le récapitulatif le dit (« … (découpé dans un plan de 800 mm) » → « …, découpé … ») */
  function nomLigne(n) { var s = n.replace(/\s*\(([^)€]+)\)/g, ', $1'); return s.charAt(0).toLowerCase() + s.slice(1); }
  function texteRemplace(d, t, mode) {
    if (!d.moins.length) return '';
    var noms = d.moins.map(function (m) { return nomCourt(m.nom); }).filter(function (n, i, a) { return n && a.indexOf(n) === i; });
    var nt = nomType(t, mode);
    var debut = noms.length === 1 && noms[0] === nt ? 'Remplace sur ce côté : le ' + nt + ' déjà posé.' : 'Remplace sur ce côté : ' + noms.join(', ') + '.';
    return debut + ' ' + (d.total ? 'Écart sur le total : ' + signe(d.total) + '.' : 'Aucun écart sur le total.');
  }
  /* bulle d'A-304 : ce que le choix ajoute d'office (lignes autres que la sienne, prix de base) */
  function texteAjout(d, t, mode) {
    var re = { round1: /arrondi/i, semi: /demi-rond/i, notch: /encoche/i, bevel: /chanfrein/i, biais: mode === 'hors' ? /hors/i : /biais/i }[t];
    var aj = d.plus.filter(function (p) { return !(re && re.test(p.nom)); }), ph = [];
    if (d.base) ph.push((/fini|côtés finis/i.test(d.baseTexte) && !/fini|côtés finis/i.test(d.baseAvant) ? 'Ce choix fait passer le plan en fini 4 côtés' : 'Ce choix change le prix de base') + ' : ' + signe(d.base) + '.');
    if (aj.length) ph.push((ph.length ? 'Il ajoute aussi : ' : 'Ce choix ajoute aussi : ') + aj.map(function (p) { return nomLigne(p.nom) + ' : ' + signe(p.c); }).join(' ; ') + '.');
    return ph.length ? ph.join(' ') + ' Écart sur le total : ' + signe(d.total) + '.' : '';
  }
  window.CP_texteAjout = texteAjout;                                   /* R180 : la même bulle au passage d'épaisseur (cp-modele) */
  /* fenêtre ouverte par un badge (cp-pierre-angle), rien de posé avant APPLIQUER : f pose ce qu'APPLIQUER poserait ;
     retrait : f retire ce qui est en place (son coût, inversé). → { total, remplace } pour pop.__cpEcart */
  window.CP_annonce = function (A, f, t, mode, retrait, k) {
    var r = simule(A, [f]); if (!r.apres[0]) return null;
    var d = ecart(r.avant, r.apres[0]);
    return { total: retrait ? -d.total : d.total, remplace: retrait ? '' : texteRemplace(d, t, mode), k: k || null, quand: Date.now() };
  };
  /* bulle de cp-modele après un rendu où un coin a changé de type : son texte (cp-modele l'appelle avant le sien) */
  window.CP_bulleChoix = function (A, k) {
    if (!enCours || enCours.k !== k || !A) return null;
    try { return texteAjout(ecart(enCours.avant, lire(A)), enCours.t, enCours.mode); } catch (e) { return null; }
  };
  function pastille(pop, d) {
    var tg = pop.querySelector('#edge-popup-title .ep-tag'); if (!tg) return;
    var base = (tg.textContent || '').split('·')[0].trim();
    tg.textContent = base + ' · ' + signe(d);
  }
  function ligneRemplace(pop, txt) {
    var content = pop.querySelector('#edge-popup-content'); if (!content) return;
    var old = content.querySelector('.cp-remplace'); if (old) old.remove();
    if (!txt) return;
    var p = document.createElement('p'); p.className = 'cp-remplace'; p.setAttribute('role', 'status'); p.textContent = txt;
    p.style.cssText = 'margin:0 0 .5rem;font-size:13px;line-height:1.35;color:#7a4a0c;background:#fff7ec;border:1px solid #e8a33d;border-radius:6px;padding:.4rem .55rem';
    content.insertBefore(p, content.firstChild);
  }
  var fenVue = null;
  function fenetre(A) {
    var pop = document.getElementById('edge-dims-popup'); if (!pop || pop.classList.contains('hidden') || SIM) return;
    var titre = pop.querySelector('#edge-popup-title'), sig = titre ? titre.textContent : '';
    if (fenVue && fenVue.pop === pop && fenVue.sig === sig && fenVue.k === A.currentEdgeKey) return;
    fenVue = { pop: pop, sig: sig, k: A.currentEdgeKey };
    var d = null, rempl = '', ce = pop.__cpEcart; pop.__cpEcart = null;
    if (ce && Date.now() - ce.quand < 3000 && (pop.__cpInt || ce.k === A.currentEdgeKey)) { d = ce.total; rempl = ce.remplace || ''; }   /* badge (cp-pierre-angle) : calculé avant d'ouvrir */
    else if (pop.__cpInt) return;                                       /* angle intérieur sans écart fourni : pastille inchangée */
    else if (enCours && !enCours.garde && enCours.k === A.currentEdgeKey) {
      enCours.fenetre = true;
      var e = ecart(enCours.avant, lire(A)); d = e.total; rempl = texteRemplace(e, enCours.t, enCours.mode);
    } else if (A.currentEdgeKey && (A.S.edges || {})[A.currentEdgeKey] && A.S.edges[A.currentEdgeKey] !== 'straight') {
      var k = A.currentEdgeKey, r = simule(A, [function (B) { return choix(B, k, 'straight'); }]);   /* type en place : ce qu'il coûte */
      if (r.apres[0]) d = r.avant.total - r.apres[0].total;
    }
    if (d != null) pastille(pop, d);
    ligneRemplace(pop, rempl);
    fenVue.sig = titre ? titre.textContent : '';                       /* après la pastille réécrite : l'observateur ne repart pas */
  }
  /* fenêtre fermée sans APPLIQUER après un choix du menu : l'état d'avant le choix (A-306). Appelé dans la fermeture même
     (closeEdgePopup), avant qu'un autre menu s'ouvre dans le même clic */
  function fermeture(A) {
    var c = enCours; if (!c) return;
    enCours = null; fenVue = null;
    if (c.garde || c.valide || !c.fenetre) return;
    remet(A, c.photo); A.render();
  }

  /* ── branchements : le menu et la fenêtre sont observés (le moteur et les modules les ouvrent de plusieurs façons) ── */
  function brancher(A) {
    var menu = document.getElementById('edge-menu'), pop = document.getElementById('edge-dims-popup');
    if (!menu || !pop || A.__cpAnnonces) return !!A.__cpAnnonces;
    A.__cpAnnonces = true;
    new MutationObserver(function () {
      if (SIM || menu.classList.contains('hidden')) { menuVu = null; return; }
      enveloppeMenu(A);                                                /* en dernier, au-dessus de cp-pierre-angle (menuCoin) */
      if (!menuVu || menuVu.k !== A.menuTarget) try { prixMenu(A); } catch (e) { console.warn('[cp-annonces]', e); }
    }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(function () {
      if (SIM) return;
      if (pop.classList.contains('hidden')) { if (enCours && enCours.fenetre) try { fermeture(A); } catch (e) { console.warn('[cp-annonces]', e); } return; }   /* cachée sans closeEdgePopup */
      try { fenetre(A); } catch (e) { console.warn('[cp-annonces]', e); }
    }).observe(pop, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
    var oFerme = A.closeEdgePopup;
    if (typeof oFerme === 'function') A.closeEdgePopup = function () {
      var ouverte = !pop.classList.contains('hidden'), r = oFerme.apply(this, arguments);
      if (ouverte && !SIM) try { fermeture(this); } catch (e) { console.warn('[cp-annonces]', e); }
      return r;
    };
    return true;
  }
  /* ── A-312 : menus et feuilles de la barre (.config-popup : Forme, Finition, Épaisseur…) devant le bandeau de consentement
     de Shopify (z 2 000 000, fixé en bas à la 1re visite), comme les fenêtres des coins (A-297) : tant qu'une feuille est
     ouverte, elle et ses parents qui font un contexte d'empilement passent au-dessus du bandeau, puis reprennent leur valeur.
     Le bandeau n'est ni fermé ni répondu à la place du client. ── */
  function bandeau() {
    var b = document.getElementById('shopify-pc__banner'); if (!b) return null;
    var cs = getComputedStyle(b); if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    var r = b.getBoundingClientRect(); return r.height > 0 && r.top < document.documentElement.clientHeight ? { z: Number(cs.zIndex) || 2000000, top: r.top } : null;
  }
  var levees = null;
  function feuilles() {
    var ouv = Array.prototype.filter.call(document.querySelectorAll('.config-popup.is-open'), visible), b = bandeau();
    if (ouv.length && b && !levees) {
      levees = [];
      ouv.forEach(function (f) {
        for (var a = f; a && a !== document.body && a !== document.documentElement; a = a.parentElement) {
          var cs = getComputedStyle(a); if (cs.position === 'static' || cs.zIndex === 'auto' || levees.some(function (x) { return x.el === a; })) continue;
          levees.push({ el: a, z: a.style.getPropertyValue('z-index'), p: a.style.getPropertyPriority('z-index') });
          a.style.setProperty('z-index', String(b.z + 1), 'important');
        }
      });
    } else if ((!ouv.length || !b) && levees) {
      levees.forEach(function (x) { if (x.z) x.el.style.setProperty('z-index', x.z, x.p); else x.el.style.removeProperty('z-index'); });
      levees = null;
    }
  }
  function veilleFeuilles() {
    var fs = document.querySelectorAll('.config-popup'); if (!fs.length || typeof MutationObserver !== 'function') return false;
    var ob = new MutationObserver(function () { try { feuilles(); } catch (e) { console.warn('[cp-annonces]', e); } });
    Array.prototype.forEach.call(fs, function (f) { ob.observe(f, { attributes: true, attributeFilter: ['class'] }); });
    var bn = document.getElementById('shopify-pc__banner'); if (bn) ob.observe(bn, { attributes: true, attributeFilter: ['style', 'class'] });
    return true;
  }
  var essaisF = 0, minuF = setInterval(function () { if (veilleFeuilles() || ++essaisF > 400) clearInterval(minuF); }, 50);

  /* ── A-344 : les fenêtres du configurateur et le bandeau de consentement, sur toutes les fiches (règle d'A-297, qui ne
     gardait que les coins de la pierre). Une fenêtre qui tient au-dessus du bandeau y remonte : décalage par « translate »,
     sans toucher à la place que lui donne son module. Sinon elle passe devant lui, à sa place : son z-index passe au-dessus
     du bandeau, et ses parents qui font un contexte d'empilement (#stage, .config) le perdent (z-index auto) tant qu'elle est
     ouverte. Lever ces parents, comme A-297, couvrait les boutons du bandeau ; ici ils restent visibles et touchables. Tout
     reprend sa valeur à la fermeture, rien ne bouge sans bandeau. La bulle du chant arrière suit sa case : elle passe devant,
     sans bouger. Fenêtre de l'étagère : la boîte remonte, le voile passe devant. ── */
  /* A-412 : la fenêtre « Gardez votre configuration » (R192) aussi, comme celle de l'étagère : la boîte remonte, le voile passe devant */
  /* A-425 (AUDIT Tour 1170) : la fenêtre des jambages aussi (elle passait sous le bandeau, « + » et APPLIQUER cachés) */
  var FENETRES = [{ id: 'edge-dims-popup' }, { id: 'edge-menu' }, { id: 'cp-dec-dlg' }, { id: 'cp-etag-dlg', boite: '.cpd-box' }, { id: 'cp-back-bulle', fixe: true }, { id: 'cp-lien-dlg', boite: '.cpl-box' },
    { id: 'legs-popup', boite: '.legs-popup-content' }];
  var DECALEES = {}, PROPRES = {}, NEUTRES = [];
  function rendZ(x) { if (x.v) x.el.style.setProperty('z-index', x.v, x.p); else x.el.style.removeProperty('z-index'); }
  function garde() {
    var b = bandeau(), M = 10, devant = [];
    FENETRES.forEach(function (f) {
      var el = document.getElementById(f.id), bo = el && f.boite ? el.querySelector(f.boite) : el, d = 0, dc = DECALEES[f.id], pr = PROPRES[f.id];
      if (dc && dc.el !== bo) { dc.el.style.removeProperty('translate'); dc = DECALEES[f.id] = null; }   /* fenêtre refaite par son module */
      if (bo && b && !el.hidden && !el.classList.contains('hidden') && visible(el) && visible(bo)) {
        var r = bo.getBoundingClientRect(), d0 = dc ? dc.d : 0;                     /* place sans le décalage */
        if (!f.fixe && r.height <= b.top - 2 * M) d = Math.max(0, Math.min(r.bottom + d0 - (b.top - M), r.top + d0 - M));
        else devant.push(el);
      }
      if (d > 0 && (!dc || dc.d !== d)) { bo.style.setProperty('translate', '0 ' + (-d) + 'px'); DECALEES[f.id] = { el: bo, d: d }; }
      else if (!(d > 0) && dc) { dc.el.style.removeProperty('translate'); DECALEES[f.id] = null; }
      if (devant.indexOf(el) >= 0) {
        if (!pr || pr.el !== el) {
          if (pr) rendZ(pr);
          PROPRES[f.id] = { el: el, v: el.style.getPropertyValue('z-index'), p: el.style.getPropertyPriority('z-index') };
          el.style.setProperty('z-index', String(b.z + 1), 'important');
        }
      } else if (pr) { rendZ(pr); PROPRES[f.id] = null; }
    });
    /* parents qui font un contexte d'empilement (position et z-index), sauf ceux qu'A-312 a déjà passés devant le bandeau */
    var veut = [], deja = function (a) { return NEUTRES.some(function (x) { return x.el === a; }); };
    devant.forEach(function (el) {
      for (var a = el.parentElement; a && a !== document.body && a !== document.documentElement; a = a.parentElement) {
        if (veut.indexOf(a) >= 0) continue;
        var cs = deja(a) ? null : getComputedStyle(a);
        if (!cs || (cs.position !== 'static' && cs.zIndex !== 'auto' && !(levees && levees.some(function (x) { return x.el === a; })))) veut.push(a);
      }
    });
    NEUTRES = NEUTRES.filter(function (x) { if (veut.indexOf(x.el) >= 0) return true; rendZ(x); return false; });
    veut.forEach(function (a) {
      if (deja(a)) return;
      NEUTRES.push({ el: a, v: a.style.getPropertyValue('z-index'), p: a.style.getPropertyPriority('z-index') });
      a.style.setProperty('z-index', 'auto', 'important');
    });
  }
  /* appelé par les modules qui placent une fenêtre (cp-pierre-angle) ; sinon à chaque changement, au plus une fois par image */
  /* pendant une simulation (prix annoncés), rien : l'état de la page y est provisoire. requestAnimationFrame pris au
     chargement : sansMinuteurs le remplace le temps d'une simulation */
  var prevueG = false, rafG = window.requestAnimationFrame.bind(window);
  function planifie() { if (prevueG) return; prevueG = true; rafG(function () { prevueG = false; window.CP_devantBandeau(); }); }
  window.CP_devantBandeau = function () { if (SIM) { planifie(); return; } try { garde(); } catch (e) { console.warn('[cp-annonces]', e); } };
  var suivies = [], obG = null;
  function suivre() {
    if (!obG) {
      if (typeof MutationObserver !== 'function') return true;
      if (!document.body) return false;
      obG = new MutationObserver(planifie);
      new MutationObserver(function () { suivre(); planifie(); }).observe(document.body, { childList: true });   /* découpes, étagère, bulle : posées dans body */
      window.addEventListener('resize', planifie);
    }
    FENETRES.map(function (f) { return document.getElementById(f.id); }).concat([document.getElementById('shopify-pc__banner')]).forEach(function (el) {
      if (!el || suivies.indexOf(el) >= 0) return;
      suivies.push(el); obG.observe(el, { attributes: true, attributeFilter: ['style', 'class', 'hidden'], childList: true, subtree: true });
    });
    suivies = suivies.filter(function (el) { return el.isConnected; });
    return !!document.getElementById('edge-dims-popup');
  }
  var essaisG = 0, minuG = setInterval(function () { if (suivre() || ++essaisG > 400) clearInterval(minuG); }, 50);

  var essais = 0, minu = setInterval(function () {
    var A = getApp();
    if ((A && A.menu && brancher(A)) || ++essais > 400) clearInterval(minu);
  }, 50);
})();
